export default __webpack_public_path__ + "locales/it/Webhooks.json?hash=2a70873a932aa275951c9e5d56042b70";